(function(){
  function buildPyramid(){
    document.querySelectorAll('details').forEach(function(det){
      var sum=det.querySelector('summary');
      if(!sum||sum.textContent.indexOf('Descri')<0)return;
      var cont=det.querySelector('.accordion__content');
      if(!cont||cont.querySelector('.na-pyramid'))return;
      var titleEl=null;
      var h4s=cont.querySelectorAll('h4');
      for(var i=0;i<h4s.length;i++){if(h4s[i].textContent.indexOf('Pir')>=0){titleEl=h4s[i];break;}}
      if(!titleEl)return;
      var ulEl=titleEl.nextElementSibling;
      if(!ulEl||ulEl.tagName!=='UL')return;
      var lis=ulEl.querySelectorAll('li');
      if(lis.length<3)return;
      function clean(li){return li.textContent.replace(/^Notas? de [^:]+:\s*/i,'').trim();}
      var t=clean(lis[0]),c=clean(lis[1]),f=clean(lis[2]);
      var div=document.createElement('div');
      div.innerHTML='<div class="na-pyramid">'
        +'<div class="na-pyramid__title"><span>&#127807;</span> Pir&acirc;mide Olfativa</div>'
        +'<div class="na-pyramid__cards">'
        +'<div class="na-pyramid__card na-pyramid__card--topo"><span class="na-pyramid__icon">&#10024;</span><span class="na-pyramid__label">Notas de Topo</span><p class="na-pyramid__text">'+t+'</p></div>'
        +'<div class="na-pyramid__card na-pyramid__card--coracao"><span class="na-pyramid__icon">&#127800;</span><span class="na-pyramid__label">Notas de Cora&ccedil;&atilde;o</span><p class="na-pyramid__text">'+c+'</p></div>'
        +'<div class="na-pyramid__card na-pyramid__card--fundo"><span class="na-pyramid__icon">&#129717;</span><span class="na-pyramid__label">Notas de Fundo</span><p class="na-pyramid__text">'+f+'</p></div>'
        +'</div></div>';
      titleEl.parentNode.insertBefore(div,titleEl);
      titleEl.style.display='none';
      ulEl.style.display='none';
    });
  }
  if(document.readyState==='complete'){buildPyramid();}
  else{window.addEventListener('load',buildPyramid);}
  setTimeout(buildPyramid,600);
})();